import { DateRangeField } from '@shared/data/entity/fields/DateRangeField';
import { getPartialFormattedDateTimeRangeParts } from '@shared/util/date';
import { i18n } from '@shared/util/i18n';

/**
 * A date range on one line, as FormattedDateRange shows it: the two ends joined by an en dash,
 * with a placeholder for a missing one: "Oct 1 – End date".
 */
export function getDateRangeText(field: DateRangeField): string {
  const { start, end } = field.dateRange;
  const { from, to } = getPartialFormattedDateTimeRangeParts(start, end);
  return [
    from ?? i18n('workflowTemplate.component.dateRange.startPlaceholder'),
    to ?? i18n('workflowTemplate.component.dateRange.endPlaceholder'),
  ].join(' – ');
}
